import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../../store';
import { KnownShipperSpecs } from '../../static/resources/knownShipperSpecs';

export interface ConveyorFilterProps {
  shipperOptions: number[];
  toggleLegend: boolean;
  toggleCore: boolean;
}

const initialState: ConveyorFilterProps = {
  shipperOptions: [0],
  toggleLegend: true,
  toggleCore: true,
};

export const conveyorFilterSlice = createSlice({
  name: 'conveyorFilter',
  initialState,
  reducers: {
    setShipperOptions: (state, action: PayloadAction<number>) => {
      let value = action.payload;

      const currentIndex = state.shipperOptions.indexOf(value);
      const newChecked = [...state.shipperOptions];

      let allOptionId: number | undefined = KnownShipperSpecs.find((x) => x.name === 'All')?.id;

      if (value === allOptionId) {
        state.shipperOptions = [allOptionId];
        return;
      }

      if (currentIndex === -1) {
        newChecked.push(value);
      } else {
        newChecked.splice(currentIndex, 1);
      }

      if (newChecked.length > 0 && newChecked.includes(allOptionId ? allOptionId : 0)) {
        newChecked.splice(newChecked.indexOf(allOptionId ? allOptionId : 0), 1);
      }

      if (newChecked.length === 0) {
        newChecked.push(allOptionId ? allOptionId : 0);
      }

      state.shipperOptions = newChecked;
    },
    setToggleLegend: (state) => {
      state.toggleLegend = !state.toggleLegend;
    },
    setToggleCore: (state) => {
      state.toggleCore = !state.toggleCore;
    },
  },
});

export const { setShipperOptions, setToggleLegend, setToggleCore } = conveyorFilterSlice.actions;

export const selectShipperFilterOptions = (state: RootState) => state.conveyorFilter.shipperOptions;
export const selectToggleLegend = (state: RootState) => state.conveyorFilter.toggleLegend;
export const selectToggleCore = (state: RootState) => state.conveyorFilter.toggleCore;

export default conveyorFilterSlice.reducer;
